import { render, staticRenderFns } from "./FigmaLayersTree.vue?vue&type=template&id=53078f50"
import script from "./FigmaLayersTree.vue?vue&type=script&lang=js"
export * from "./FigmaLayersTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports